export default __webpack_public_path__ + "static/media/ami-logo-black@2x.c0987484.png";